import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=33c81dee&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c81dee')) {
      api.createRecord('33c81dee', component.options)
    } else {
      api.reload('33c81dee', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=33c81dee&", function () {
      api.rerender('33c81dee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2i84b91DXDHi0/JS/pricehelp.vue"
export default component.exports